import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { DownloadLeaderboardExcelRequest, ViewLeaderboardRequest } from './leaderboard.types';

import { requestDownloadLeaderboardExcel, requestViewLeaderboard } from './leaderboard.actions';

export const useLeaderboardApi = () => {
  const dispatch = useDispatch();

  const viewLeaderboard = useCallback(
    (requestData: ViewLeaderboardRequest, onSuccess?: () => void) => {
      dispatch(requestViewLeaderboard({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const downloadLeaderboardExcel = useCallback(
    (requestData: DownloadLeaderboardExcelRequest, onSuccess?: (base64: string) => void) => {
      dispatch(requestDownloadLeaderboardExcel({ requestData, onSuccess }));
    },
    [dispatch]
  );

  return { viewLeaderboard, downloadLeaderboardExcel };
};
